import { getStatusName } from "../../utils/Order/Order"

export const TransactionStatus = {
	ROUTED: 'PendingNew',
	FILLED: 'Filled',
	CANCEL_PENDING: 'PendingCancel',
	CANCELED: 'Canceled',
	REJECTED: 'Rejected',
	AMENDING: 'PendingReplace',
	ACKED: 'New',
	PARKED: 'Parked',
	AUTH_WAIT: 'WaitingAuthorization'
}

export const IOType = {
  Deposit: 'Deposit',
  Withdraw: 'Withdraw',
  Transfer: 'Transfer',
  Redemption: "Redemption",
  Subscription: "Subscription"
}

export const IOMode = {
  Simple: 'Simple',
  MultipleAccounts: 'Multiple Accounts',
  MultipleAssets: 'Multiple Assets'
}

export const TransferType = {
  Client: 'Client',
  Custodian: 'Custodian',
  PropClient: 'PropClient'
}

export const CurrencyAsset = {
  Cash: 'Cash',
  Asset: 'Asset'
}

export const ContextType = {
  Local: 'Local',
  INTL: 'INTL'
}

export const IOTransferType = {
  Cash: 'Cash',
  Transfer: 'Transfer',
  Cheque: 'Cheque'
}

/** Selectors */

export const getIOTypeName = (iotype) => {
  return iotype;
}

export const getIOProcessName = (io) => {
  if (io.IOType != IOType.Transfer) {
    if (io.IOMode == io.MultipleAccounts) {
      return `Bulk${io.IOType}`
    }
  }

  return `${io.IOType}`
}

export const getTransactionStatusName = (iostatus) => getStatusName(iostatus);